var Gadget = /** @class */ (function () {
    function Gadget() {
        this.html = "";
        this.gadgets = new Array();
    }
    Gadget.prototype.addGadget = function (gadget) {
        this.gadgets.push(gadget);
    };
    Gadget.prototype.parseGadgets = function () {
        var tmp = "";
        this.gadgets.forEach(function (g) {
            tmp += g.render();
        });
        this.html = tmp;
    };
    Gadget.prototype.render = function (forceParseGadgets) {
        if (forceParseGadgets === void 0) { forceParseGadgets = true; }
        if (forceParseGadgets && this.html == "")
            this.parseGadgets();
        return this.html;
    };
    Gadget.prototype.getHtml = function () {
        return this.html;
    };
    Gadget.prototype.setHtml = function (html) {
        this.html = html;
    };
    Gadget.prototype.appendToContent = function (finished) {
        $('#page_content').append(this.render());
        if (finished != undefined)
            finished();
    };
    Gadget.prototype.execute = function (e) { };
    return Gadget;
}());
export { Gadget };
